import { Typography } from '@mui/material';
import { Link } from 'react-router';

import { url } from '../../appRouter/url';
import { type ThemaFromThemaRouter } from '../../dtos';
import { getPendantLabel } from '../../utils/isOnline';
import { LabelValue } from './LabelValue';
import { content } from './Pendant.content';

export const PendantLabelValue = ({ thema }: { readonly thema: ThemaFromThemaRouter }) => {
  const { pendantThemen } = thema;

  if (pendantThemen.length === 0) {
    return null;
  }

  if (pendantThemen.length > 1) {
    return (
      <Typography variant="labelLight" color="textPrimaryOnBrand">
        {content.mehrerePendants}
      </Typography>
    );
  }

  const [pendant] = pendantThemen;
  return (
    <LabelValue
      color="brand"
      label={getPendantLabel(pendant)}
      value={
        <Link to={url.thema.details(pendant.akaThemaId)} target="_blank" style={{ textDecorationColor: 'white' }}>
          <Typography color="textPrimaryOnBrand" variant="labelLight" component="p">
            {pendant.akaThemaId}
          </Typography>
        </Link>
      }
    />
  );
};
